import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { gaodeMapJS } from "@/common/add-js";
import { State } from "vuex-class";
// import i18n from "@/config/i18n";
import { getMapStaList, getMapStaInfo, getOprInfo, } from "@/api/api-operation-service";
import homeMapScreen from "./components/pi-home-map-screen/pi-home-map-screen.vue";
import homeMapGunStatus from "./components/pi-home-map-gun-status/pi-home-map-gun-status.vue";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
let PiHomeMap = class PiHomeMap extends Vue {
    constructor() {
        super(...arguments);
        this.formInlineData = {}; // 查询条件
        this.mapFull = false;
        this.isLodingFull = false;
        this.map = {};
        this.win = window;
        this.isMap = false;
        this.markerList = [];
        this.points = [];
        this.allMarkerList = [];
        this.oprInfo = {};
        this.infoWindow = {};
        this.dcImg = require("@/assets/home/dc.png");
        this.acImg = require("@/assets/home/ac.png");
        this.carImg = require("@/assets/home/sta-car.png");
        this.pileImg = require("@/assets/home/map-sta.png");
        this.MarkerClusterer = {};
        this.staPkId = ""; // 选择中的站点，用在点的隐藏和显示
        this.clickMarkObj = {}; // 选择中的点标记
        this.clickMarkAllObj = {}; // 所有点标记对象
    }
    "Watch.getIndex"() {
        let homeMap = this.$refs.homeMap || {};
        if (!this.isMap || homeMap.innerHTML == "") {
            this.mapShow();
        }
    }
    /**
     * 全屏
     */
    fullClick() {
        if (!this.isLodingFull) {
            this.isLodingFull = true;
        }
        this.mapFull = !this.mapFull;
    }
    /**高级搜索条件 */
    searchChange(data, isAll) {
        this.formInlineData = Object.assign(this.formInlineData, data);
        this.getCityMarker(isAll);
    }
    /**
     * 普通搜索
     */
    // public screenStaName(data: objAny[]): void {
    //   this.cityMarkerData(data);
    // }
    /**
     * 普通到的站点点击搜索
     */
    screenStaNameClick(item) {
        item.lat = item.staLat;
        item.lng = item.staLng;
        this.getStaInfos(item);
    }
    /**
     * 获取地图点标记
     */
    async getCityMarker(isAll) {
        const ret = await getMapStaList({
            ...this.formInlineData,
            merchantPkIdList: [this.sys.userInfo.merchantPkId],
        });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data;
            if (isAll) {
                this.allMarkerList = data;
            }
            this.cityMarkerData(data);
        }
    }
    /**
     * 地图点标记数据
     */
    cityMarkerData(data) {
        this.infoWindow.close && this.infoWindow.close();
        const markerList = [];
        const points = [];
        data.map((item, index) => {
            markerList.push({
                lat: item.staLat,
                lng: item.staLng,
                staPkId: item.staPkId,
                staName: item.staName,
            });
            points.push({
                weight: 8,
                lnglat: [item.staLng, item.staLat],
                index: index,
                staPkId: item.staPkId,
                staName: item.staName,
            });
        });
        this.markerList = markerList;
        this.points = points;
        this.mapShow();
    }
    /**
     * 地图显示
     */
    mapShow() {
        if (!this.win.AMap) {
            setTimeout(() => {
                this.mapShow();
            }, 500);
            return;
        }
        let homeMap = this.$refs.homeMap || {};
        if (!this.isMap || homeMap.innerHTML == "") {
            let center = [];
            let zoom = 8;
            center = [this.oprInfo.lng, this.oprInfo.lat];
            let lang = this.$i18n.locale.split("-")[0];
            this.map = new this.win.AMap.Map("map", {
                resizeEnable: true,
                center: center,
                zoom: zoom,
                lang: lang,
            });
            this.isMap = true;
        }
        else {
            // 清除所有聚合点
            this.clearMarker();
        }
        this.MarkerClusterer = new this.win.AMap.MarkerCluster(this.map, this.points, {
            gridSize: 80,
            renderClusterMarker: this._renderCluserMarker,
            renderMarker: this._renderMarker,
        });
        // 聚合点击 ， 有聚合没放大，没有就是站点点击
        this.MarkerClusterer.on("click", (mark) => {
            const clusterData = mark.clusterData[0];
            if (mark.clusterData.length > 1) {
                const zoom = this.map.getZoom() + 2;
                this.map.setZoomAndCenter(zoom, [
                    clusterData.lnglat.lng,
                    clusterData.lnglat.lat,
                ]);
            }
            else {
                let index = this.markerList.findIndex((item) => {
                    return item.lat == mark.lnglat.lat && item.lng == mark.lnglat.lng;
                });
                this.getStaInfos(this.markerList[index]);
            }
        });
        this.map.on("click", () => {
            this.staPkId = "";
            this._renderMarker(this.clickMarkObj);
            this.infoWindow.close && this.infoWindow.close();
        });
    }
    /**
     * 清除点聚合
     */
    clearMarker() {
        this.MarkerClusterer.setMap(null);
        this.map.clearMap();
        this.staPkId = "";
        this.clickMarkAllObj = {};
    }
    /**
     * 聚合样式
     */
    _renderCluserMarker(context) {
        const div = document.createElement("div");
        div.innerHTML = context.count;
        let size = 60;
        if (context.count < 10) {
            div.className = "dian-bg small";
            size = 60;
        }
        else if (context.count < 100) {
            div.className = "dian-bg large";
            size = 72;
        }
        else if (context.count > 100) {
            div.className = "dian-bg greatly";
            size = 88;
        }
        context.marker.setOffset(new this.win.AMap.Pixel(-size / 2, -size / 2));
        context.marker.setContent(div);
    }
    /**
     * 单个点的样式
     */
    _renderMarker(context) {
        let data = context.data[0];
        let index = data.index || "";
        let staPkId = data.staPkId || "";
        let staName = data.staName || "";
        let className = this.staPkId == staPkId ? "hide" : "";
        const content = `<div class="dian-def dian-site-${index} ${className}" data-index="${index}" data-id="${staPkId}">
      <div class="sta-icon"><img src="${this.pileImg}" /></div>
      <div class="sta-name text-hide">${staName}</div>
    </div>`;
        let width = 60 + staName.length * 12; // 按字体大小大概算出长度
        if (width > 212) {
            width = 212;
        }
        const offset = new this.win.AMap.Pixel(-(width / 2 + 6), -48);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        if (this.staPkId && this.staPkId == staPkId) {
            this.clickMarkObj = context;
        }
        if (staPkId) {
            this.clickMarkAllObj[staPkId] = context;
        }
    }
    /**
     * 请求站点信息框信息
     */
    async getStaInfos(item) {
        this.staPkId = item.staPkId;
        const ret = await getMapStaInfo({ staPkId: item.staPkId });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.openInfos(data, item);
            if (this.clickMarkAllObj[item.staPkId]) {
                this._renderMarker(this.clickMarkAllObj[item.staPkId]);
            }
        }
    }
    /**
     * 打开站点信息框
     */
    async openInfos(data, item) {
        const info = `
          <div class="map-site-info">
            <div class="site-name-box">
              <div class="site-name text-hide" id="site-name">${data.staName}<i class="iconfont icon-youjiantou"></i>
              <img class="name-bg" src="${this.carImg}" class="" />
              </div>
              <div class="site-status">${data.staStatusDesc}</div>
            </div>
            <div class="site-info">
              <div class="site-info-text">
                <i class="iconfont icon-zhandian1"></i>${data.staAddress}
              </div>
              <div class="site-info-text">
              <i class="iconfont icon-dianhua"></i>${data.phoneNo}
              </div>
              <div class="site-pile-box">
                <div class="site-pile-flex">
                  <img src="${this.dcImg}">${data.dcPileCount}
                </div>
                <div class="site-pile-flex">
                  <img src="${this.acImg}">${data.acPileCount}
                </div>
              </div>
            </div>
          </div>
      `;
        this.infoWindow = new this.win.AMap.InfoWindow({
            content: info,
            offset: new this.win.AMap.Pixel(0, 0),
        });
        this.infoWindow.open(this.map, [item.lng, item.lat]);
        this.siteClick();
        // this.siteDetailClick();
    }
    /**
     * 点击站点信息框的详情
     */
    // public siteDetailClick(): void {
    //   const router = this["$router"];
    //   const staPkId = this.staPkId;
    //   const oprPkId = this.sys.operInfo.oprPkId || "";
    //   setTimeout(() => {
    //     const divObj = document.getElementById("site-detail");
    //     if (divObj != null) {
    //       divObj.onclick = function () {
    //         router.push(
    //           "/home/index/home-pile?staPkId=" + staPkId + "&oprPkId=" + oprPkId
    //         );
    //       };
    //     } else {
    //       this.siteDetailClick();
    //     }
    //   }, 500);
    // }
    /**
     * 跳转站点详情
     */
    siteClick() {
        const router = this["$router"];
        setTimeout(() => {
            const divObj = document.getElementById("site-name");
            if (divObj != null) {
                const staPkId = this.staPkId;
                divObj.onclick = function () {
                    router.push("/pile-manage/pile-info/detail?staPkId=" + staPkId);
                };
            }
            else {
                this.siteClick();
            }
        }, 500);
    }
    /**
     * 获取运营商信息，在 vuex 上
     */
    async getOprInfo() {
        let ret = await getOprInfo({});
        if (ret.status === this.$config.apiStatus) {
            this.oprInfo = ret.data[0] || {};
        }
        await gaodeMapJS();
        this.getCityMarker(true);
    }
    mounted() {
        this.$nextTick(this.getOprInfo);
    }
};
__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], PiHomeMap.prototype, "formInline", void 0);
__decorate([
    Prop({
        default: 0,
    })
], PiHomeMap.prototype, "getIndex", void 0);
__decorate([
    Watch("getIndex")
], PiHomeMap.prototype, "Watch.getIndex", null);
__decorate([
    State("sys")
], PiHomeMap.prototype, "sys", void 0);
PiHomeMap = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
            "pi-home-map-screen": homeMapScreen,
            "pi-home-map-gun-status": homeMapGunStatus,
        },
    })
], PiHomeMap);
export default PiHomeMap;
